import { colord } from "colord";

export const isColorTransparent = (color: string) => {
  if (!color || color.startsWith("var(")) {
    return false;
  }

  try {
    const parsedColor = colord(color);
    return parsedColor.alpha() === 0;
  } catch {
    return false;
  }
};
